import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { Actions as COMPANYACTIONS } from '../../../store/actions/companyActions';
import { Actions as PAYMENTACTIONS } from "../../../store/actions/paymentActions";
import _, { min } from 'lodash';
import { ArrowsRightLeftIcon, XMarkIcon } from "@heroicons/react/20/solid";
import Select from 'react-select';
import { useForm, Controller } from 'react-hook-form';
import NotificationManager from "react-notifications/lib/NotificationManager";

const TransferCreditModal = ({
    isModalOpen,
    closeModal,
    companyList,
    getAdminOrganisations,
    org,
    transferCredits
}) => {

    const { watch, setValue, control, handleSubmit, register } = useForm()

    const toCompany = watch('to')
    const [amount, setAmount] = useState(0)
    const credits = org?.creditBalance - amount


    useEffect(() => {
        if (!companyList)
            getAdminOrganisations()

        setValue('to', undefined)
        setValue('description', "")
        setAmount(0)
    }, [companyList, isModalOpen])

    const onSubmit = (data) => {
        data.to = toCompany
        if (!data.to || !data.quantity || credits < 0) {
            console.trace(data.to, data.quantity, credits)
            NotificationManager.error('Please insure you have enough credits and all required fields are filled', 'Error')
        } else {
            data.toID = data.to.value
            delete data.to
            console.trace(data)
            transferCredits(data)
        }
    }

    if (!isModalOpen)
        return null

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}>
                <div className="modal-dialog" style={{ width: "600px", maxWidth: "95%", background: "white", maxHeight: "calc(100% - 151px)" }}>
                    <div className="modal-content">
                        <div className="block block-themed block-transparent remove-margin-b" style={{ paddingBottom: 60 }}>
                            <div className="block-header bg-primary-dark" style={{ padding: 20 }}>
                                <ul className="block-options">
                                    <li>
                                        <button onClick={closeModal} type="button"><XMarkIcon className="h-6 w-6 mr-3 text-white" /></button>
                                    </li>
                                </ul>
                                <h3 className="block-title">Transfer Credits From {org?.businessDetails.name}</h3>
                            </div>
                            <div className="block-content" style={{ padding: 20, paddingTop: 60 }}>

                                {/* <div className="col-sm-6" style={{ paddingLeft: 0 }}>
                                    <div className="form-material">
                                        <label htmlFor="material-text">From</label>
                                        <Controller
                                            as={Select}
                                            control={control}
                                            name="from"
                                            isDisabled
                                            options={companyList}
                                            value={fromCompany}
                                        />
                                    </div>
                                </div> */}
                                <div className="col-sm-6" style={{ paddingLeft: 0 }}>
                                    <div className="form-material">
                                        <label htmlFor="material-text">To</label>
                                        <Controller
                                            as={Select}
                                            control={control}
                                            name="to"
                                            options={companyList}
                                            value={toCompany}
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-6" style={{ paddingLeft: 0 }}>
                                    <div className="col-sm-8" style={{ paddingLeft: 0 }}>
                                        <div className="form-material">
                                            <label htmlFor="material-text">Credits</label>
                                            <input
                                                className="form-control"
                                                name="quantity"
                                                style={{ height: 36 }}
                                                ref={register}
                                                value={amount}
                                                onChange={(e) => {
                                                    if (!isNaN(e.target.value) && e.target.value >= 0 && e.target.value <= org?.creditBalance) {
                                                        setAmount(Number(e.target.value.trim()))
                                                    }
                                                }}
                                                required
                                            />
                                            <span style={{ fontSize: 11 }}><strong>Credits Remaining: </strong>{credits}</span>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-sm-6" style={{ paddingLeft: 10, paddingTop: 20 }}>
                                        <div className="col-sm-8" style={{ paddingLeft: 0 }}>
                                            <div className="form-material">
                                                <label htmlFor="material-text">Credits</label>
                                                <span style={{ fontSize: 11 }}><strong>Credits Remaining: </strong></span>
                                            </div>
                                        </div>
                                    </div> */}
                                {/* <div className="col-sm-6" style={{ paddingLeft: 0, paddingTop: 20 }}>
                                    <div className="col-sm-8" style={{ paddingLeft: 0 }}>
                                        <div className="font-w700 text-gray-darker">Active Employees</div>
                                        <div className="h2 font-w300 text-primary animated">
                                            0
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6" style={{ paddingLeft: 0, paddingTop: 20 }}>
                                    <div className="col-sm-8" style={{ paddingLeft: 0 }}>
                                        <div className="font-w700 text-gray-darker">Active Employees</div>
                                        <div className="h2 font-w300 text-primary animated">
                                            0
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                            <div className="block-content" style={{ padding: 20 }}>
                                <div className="col-sm-12" style={{ paddingLeft: 0, paddingTop: 20 }}>
                                    <label>Comment</label>
                                    <textarea
                                        className="form-control"
                                        type="text"
                                        name="description"
                                        ref={register}
                                        style={{ minHeight: 100, maxHeight: 400, resize: "vertical" }}
                                    >
                                    </textarea>
                                </div>
                            </div>
                        </div>
                        <button className="btn btn-success pull-right" style={{ marginRight: 25, marginTop: 20, marginBottom: 20 }}>
                            <ArrowsRightLeftIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                            <div style={{ float: "left" }}>Transfer Credits</div>
                        </button>
                        <div className="clearfix"></div>
                    </div>
                </div>
            </div>
        </form>
    )
}

const mapStateToProps = (state, ownProps) => {

    const adminCompanyList = state?.admin?.organisations?.map(org => ({
        label: org.name,
        value: org.id
    }))

    const companyList = state?.organisations?.map(org => ({
        label: org.name,
        value: org.id
    }))

    return {
        isModalOpen: state?.company?.billingModal == "Transfer",
        companyList: state?.my?.profile?.isAdmin ? adminCompanyList : companyList,
        org: state?.payment?.stats
    };
};

const mapDispatchToProps = dispatch => ({
    closeModal: () => dispatch(COMPANYACTIONS.setBillingModal()),
    getAdminOrganisations: () => dispatch(COMPANYACTIONS.getAdminOrganisations()),
    transferCredits: ({ quantity, description, toID}) => dispatch(PAYMENTACTIONS.transferCredits({ quantity, description, toID})),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TransferCreditModal)